export class ListJobTemplatesRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "filters",
            "baseName": "filters",
            "type": "ListJobTemplatesFilterConditions",
            "format": ""
        },
        {
            "name": "sorts",
            "baseName": "sorts",
            "type": "Array<SortJobTemplateBy>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListJobTemplatesRequest.attributeTypeMap;
    }
    constructor() {
    }
}
